export const authTranslations = {
  fr: {
    welcome: 'Bienvenue',
    description: 'Connectez-vous ou créez un compte pour accéder à Sclépios I.A',
    login: 'Connexion',
    signup: 'Inscription',
    email: 'Email',
    password: 'Mot de passe',
    signIn: 'Se connecter',
    signUp: 'S\'inscrire',
    signing: 'Connexion...',
    backToHome: 'Retour à l\'accueil',
    forgotPassword: 'Mot de passe oublié ?',
    errors: {
      alreadyExists: 'Ce compte existe déjà',
      emailUsed: 'Cette adresse email est déjà utilisée',
      invalidEmail: 'Adresse email invalide',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
      signupError: 'Erreur lors de l\'inscription',
      invalidCredentials: 'Identifiants invalides',
      emailNotConfirmed: 'Email non confirmé',
      tooManyRequests: 'Trop de tentatives, réessayez plus tard',
      loginError: 'Erreur de connexion'
    },
    success: {
      signupSuccess: 'Inscription réussie !',
      signupConfirmation: 'Vérifiez votre email pour confirmer votre compte',
      loginSuccess: 'Connexion réussie !'
    },
    passwordReset: {
      title: 'Réinitialisation du mot de passe',
      send: 'Envoyer le lien',
      sending: 'Envoi...',
      cancel: 'Annuler',
      success: 'Email de réinitialisation envoyé',
      error: 'Erreur lors de l\'envoi de l\'email'
    },
    newPassword: {
      title: 'Nouveau mot de passe',
      description: 'Choisissez un nouveau mot de passe sécurisé pour votre compte',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      update: 'Mettre à jour le mot de passe',
      updating: 'Mise à jour...',
      success: 'Mot de passe modifié avec succès !',
      error: 'Erreur lors du changement de mot de passe',
      mismatch: 'Les mots de passe ne correspondent pas',
      tooWeak: 'Le mot de passe n\'est pas assez sécurisé'
    },
    passwordRequirements: {
      title: 'Le mot de passe doit contenir :',
      length: 'Au moins 8 caractères',
      case: 'Une majuscule et une minuscule',
      number: 'Au moins un chiffre',
      special: 'Au moins un caractère spécial'
    },
    signingUp: 'Inscription...',
    emailChange: {
      successTitle: 'Email mis à jour !',
      successDesc: 'Votre adresse email a été modifiée avec succès. Redirection vers les paramètres...',
      invalidLink: 'Lien invalide ou expiré',
      linkNoLongerValid: "Le lien de confirmation d'email n'est plus valide.",
      retryFromSettings: "Veuillez refaire la procédure de changement d'email depuis les paramètres de votre compte.",
      goToSettings: 'Aller aux paramètres',
      backToLogin: 'Retour à la connexion',
    },
    recovery: {
      emailUpdated: 'Votre adresse email a été mise à jour avec succès !',
      invalidLink: 'Le lien de récupération est invalide ou a expiré. Veuillez en demander un nouveau.',
      invalidEmailLink: 'Le lien de confirmation est invalide ou a expiré. Veuillez refaire la procédure de changement d\'email.',
      enterValidEmail: 'Veuillez entrer une adresse email valide',
      sendError: 'Erreur lors de l\'envoi de l\'email',
      emailSent: 'Un nouvel email de récupération a été envoyé',
      sendFailed: 'Erreur lors de l\'envoi',
      sessionExpired: 'Session expirée. Veuillez demander un nouveau lien de récupération.',
      noActiveSession: 'Aucune session active. Le lien de récupération a peut-être été modifié par votre client mail.',
      linkExpired: 'Le lien de récupération a expiré. Veuillez en demander un nouveau.',
      invalidSession: 'Session invalide. Veuillez demander un nouveau lien de récupération.',
      samePassword: 'Le nouveau mot de passe doit être différent de l\'ancien.',
      unexpectedError: 'Erreur inattendue',
      validatingChange: 'Validation du changement d\'email...',
      referralApplied: '🎁 Code de parrainage appliqué ! +3 jours Premium offerts',
      cannotValidateEmail: 'Impossible de valider l\'adresse email. Vérifiez la configuration.',
      signupError: 'Erreur d\'inscription',
      multipleFailedAttempts: 'Plusieurs tentatives échouées. Réinitialisez votre mot de passe pour continuer.',
      resetNow: 'Réinitialiser maintenant',
      wrongCredentials: 'Email ou mot de passe incorrect. Vérifiez vos identifiants et réessayez.',
      emailNotConfirmed: 'Email non confirmé. Vérifiez votre boîte mail pour le lien de confirmation.',
      tooManyAttempts: 'Trop de tentatives. Veuillez réessayer dans quelques minutes.',
      connectionError: 'Erreur de connexion',
      genericError: 'Une erreur est survenue'
    },
    emailPlaceholder: 'votre@email.com',
    passwordStrength: {
      strength: 'Force du mot de passe',
      weak: 'Faible', medium: 'Moyen', good: 'Bon', excellent: 'Excellent',
      minChars: 'Au moins 8 caractères', uppercase: 'Une majuscule', lowercase: 'Une minuscule', digit: 'Un chiffre', special: 'Un caractère spécial (@$!%*?&)',
    }
  },
  en: {
    welcome: 'Welcome',
    description: 'Login or create an account to access Sclépios AI',
    login: 'Login',
    signup: 'Sign up',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signing: 'Signing in...',
    backToHome: 'Back to home',
    forgotPassword: 'Forgot password?',
    errors: {
      alreadyExists: 'This account already exists',
      emailUsed: 'This email address is already in use',
      invalidEmail: 'Invalid email address',
      passwordTooShort: 'Password must contain at least 6 characters',
      signupError: 'Error during signup',
      invalidCredentials: 'Invalid credentials',
      emailNotConfirmed: 'Email not confirmed',
      tooManyRequests: 'Too many attempts, try again later',
      loginError: 'Login error'
    },
    success: {
      signupSuccess: 'Successfully signed up!',
      signupConfirmation: 'Check your email to confirm your account',
      loginSuccess: 'Successfully logged in!'
    },
    passwordReset: {
      title: 'Password reset',
      send: 'Send link',
      sending: 'Sending...',
      cancel: 'Cancel',
      success: 'Password reset email sent',
      error: 'Error sending email'
    },
    newPassword: {
      title: 'New password',
      description: 'Choose a secure new password for your account',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      update: 'Update password',
      updating: 'Updating...',
      success: 'Password updated successfully!',
      error: 'Error updating password',
      mismatch: 'Passwords do not match',
      tooWeak: 'Password is not secure enough'
    },
    passwordRequirements: {
      title: 'Password must contain:',
      length: 'At least 8 characters',
      case: 'One uppercase and one lowercase',
      number: 'At least one number',
      special: 'At least one special character'
    },
    signingUp: 'Signing up...',
    emailChange: {
      successTitle: 'Email updated!',
      successDesc: 'Your email address has been changed successfully. Redirecting to settings...',
      invalidLink: 'Invalid or expired link',
      linkNoLongerValid: 'The email confirmation link is no longer valid.',
      retryFromSettings: 'Please redo the email change process from your account settings.',
      goToSettings: 'Go to settings',
      backToLogin: 'Back to login',
    },
    recovery: {
      emailUpdated: 'Your email address has been successfully updated!',
      invalidLink: 'The recovery link is invalid or has expired. Please request a new one.',
      invalidEmailLink: 'The confirmation link is invalid or has expired. Please redo the email change process.',
      enterValidEmail: 'Please enter a valid email address',
      sendError: 'Error sending the email',
      emailSent: 'A new recovery email has been sent',
      sendFailed: 'Error sending',
      sessionExpired: 'Session expired. Please request a new recovery link.',
      noActiveSession: 'No active session. The recovery link may have been modified by your email client.',
      linkExpired: 'The recovery link has expired. Please request a new one.',
      invalidSession: 'Invalid session. Please request a new recovery link.',
      samePassword: 'The new password must be different from the old one.',
      unexpectedError: 'Unexpected error',
      validatingChange: 'Validating email change...',
      referralApplied: '🎁 Referral code applied! +3 free Premium days',
      cannotValidateEmail: 'Unable to validate email address. Check the configuration.',
      signupError: 'Registration error',
      multipleFailedAttempts: 'Multiple failed attempts. Reset your password to continue.',
      resetNow: 'Reset now',
      wrongCredentials: 'Incorrect email or password. Check your credentials and try again.',
      emailNotConfirmed: 'Email not confirmed. Check your inbox for the confirmation link.',
      tooManyAttempts: 'Too many attempts. Please try again in a few minutes.',
      connectionError: 'Connection error',
      genericError: 'An error occurred'
    },
    emailPlaceholder: 'your@email.com',
    passwordStrength: {
      strength: 'Password strength',
      weak: 'Weak', medium: 'Medium', good: 'Good', excellent: 'Excellent',
      minChars: 'At least 8 characters', uppercase: 'An uppercase letter', lowercase: 'A lowercase letter', digit: 'A digit', special: 'A special character (@$!%*?&)',
    }
  },
  es: {
    welcome: 'Bienvenido',
    description: 'Inicia sesión o crea una cuenta para acceder a Sclépios IA',
    login: 'Iniciar sesión',
    signup: 'Registrarse',
    email: 'Email',
    password: 'Contraseña',
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    signing: 'Iniciando sesión...',
    backToHome: 'Volver al inicio',
    forgotPassword: '¿Olvidaste tu contraseña?',
    errors: {
      alreadyExists: 'Esta cuenta ya existe',
      emailUsed: 'Esta dirección de email ya está en uso',
      invalidEmail: 'Dirección de email inválida',
      passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
      signupError: 'Error durante el registro',
      invalidCredentials: 'Credenciales inválidas',
      emailNotConfirmed: 'Email no confirmado',
      tooManyRequests: 'Demasiados intentos, inténtalo más tarde',
      loginError: 'Error de inicio de sesión'
    },
    success: {
      signupSuccess: '¡Registro exitoso!',
      signupConfirmation: 'Revisa tu email para confirmar tu cuenta',
      loginSuccess: '¡Inicio de sesión exitoso!'
    },
    passwordReset: {
      title: 'Restablecer contraseña',
      send: 'Enviar enlace',
      sending: 'Enviando...',
      cancel: 'Cancelar',
      success: 'Email de restablecimiento enviado',
      error: 'Error al enviar email'
    },
    newPassword: {
      title: 'Nueva contraseña',
      description: 'Elige una nueva contraseña segura para tu cuenta',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      update: 'Actualizar contraseña',
      updating: 'Actualizando...',
      success: '¡Contraseña actualizada con éxito!',
      error: 'Error al actualizar la contraseña',
      mismatch: 'Las contraseñas no coinciden',
      tooWeak: 'La contraseña no es suficientemente segura'
    },
    passwordRequirements: {
      title: 'La contraseña debe contener:',
      length: 'Al menos 8 caracteres',
      case: 'Una mayúscula y una minúscula',
      number: 'Al menos un número',
      special: 'Al menos un carácter especial'
    },
    signingUp: 'Registrándose...',
    emailChange: {
      successTitle: '¡Email actualizado!',
      successDesc: 'Su dirección de email ha sido cambiada con éxito. Redirigiendo a configuración...',
      invalidLink: 'Enlace inválido o expirado',
      linkNoLongerValid: 'El enlace de confirmación de email ya no es válido.',
      retryFromSettings: 'Por favor, repita el proceso de cambio de email desde la configuración de su cuenta.',
      goToSettings: 'Ir a configuración',
      backToLogin: 'Volver al inicio de sesión',
    },
    recovery: {
      emailUpdated: '¡Su dirección de email ha sido actualizada con éxito!',
      invalidLink: 'El enlace de recuperación es inválido o ha expirado. Solicite uno nuevo.',
      invalidEmailLink: 'El enlace de confirmación es inválido o ha expirado. Repita el proceso de cambio de email.',
      enterValidEmail: 'Ingrese una dirección de email válida',
      sendError: 'Error al enviar el email',
      emailSent: 'Se ha enviado un nuevo email de recuperación',
      sendFailed: 'Error al enviar',
      sessionExpired: 'Sesión expirada. Solicite un nuevo enlace de recuperación.',
      noActiveSession: 'Sin sesión activa. El enlace de recuperación puede haber sido modificado por su cliente de email.',
      linkExpired: 'El enlace de recuperación ha expirado. Solicite uno nuevo.',
      invalidSession: 'Sesión inválida. Solicite un nuevo enlace de recuperación.',
      samePassword: 'La nueva contraseña debe ser diferente de la anterior.',
      unexpectedError: 'Error inesperado',
      validatingChange: 'Validando cambio de email...',
      referralApplied: '🎁 ¡Código de referencia aplicado! +3 días Premium gratis',
      cannotValidateEmail: 'No se puede validar la dirección de email. Verifique la configuración.',
      signupError: 'Error de registro',
      multipleFailedAttempts: 'Múltiples intentos fallidos. Restablezca su contraseña para continuar.',
      resetNow: 'Restablecer ahora',
      wrongCredentials: 'Email o contraseña incorrectos. Verifique sus credenciales e intente de nuevo.',
      emailNotConfirmed: 'Email no confirmado. Revise su bandeja de entrada para el enlace de confirmación.',
      tooManyAttempts: 'Demasiados intentos. Intente de nuevo en unos minutos.',
      connectionError: 'Error de conexión',
      genericError: 'Ocurrió un error'
    },
    emailPlaceholder: 'tu@email.com',
    passwordStrength: {
      strength: 'Seguridad de la contraseña',
      weak: 'Débil', medium: 'Media', good: 'Buena', excellent: 'Excelente',
      minChars: 'Al menos 8 caracteres', uppercase: 'Una mayúscula', lowercase: 'Una minúscula', digit: 'Un dígito', special: 'Un carácter especial (@$!%*?&)',
    }
  }
};
